/**
 * xem theo
 * nddung2 17.07.2024
 */
export default {
  Summary: 1, // tổng hợp
  DetailOrg: 2, // chi tiết đơn vị

};